import api from '../../api'
const recurrenceAPI = api.create('recurrence')

const get = async ({ clientId = '', ...params }) => {
  return await recurrenceAPI.get(`/customers/${clientId}`, { params })
}

const put = async ({ clientId = '', ...data }) => {
  return await recurrenceAPI.put(`/customers/${clientId}`, data)
}

const create = async ({ ...data }) => {
  return await recurrenceAPI.post('/customers', data)
}

const checkEmail = async data => {
  return await recurrenceAPI.post('/customers/check_email', data)
}

const checkCpf = async data => {
  return await recurrenceAPI.post('/customers/check_cpf', data)
}

const checkCnpj = async data => {
  return await recurrenceAPI.post('/customers/check_cnpj', data)
}

const search = async params => {
  return await recurrenceAPI.post('/customers/search', {}, { params })
}

export default { get, put, create, checkEmail, checkCpf, checkCnpj, search }
